<!-- Covers the app while `app.vue` runs startup (session check, profile, first screen). It carries
     on from `app/spa-loading-template.html` — the plain-HTML splash Nuxt shows until the app mounts —
     and looks exactly like it (logo only, same size and position), so the two read as one screen. -->
<template>
  <div class="fixed inset-0 z-100 flex items-center justify-center bg-background">
    <img src="/logos/logo-white.svg" alt="logo" class="size-16 hidden dark:block animate-pulse">
    <img src="/logos/logo-black.svg" alt="logo" class="size-16 dark:hidden animate-pulse">
  </div>
</template>
